import axios from 'axios';

import type {
  IUserFindOutgoingTransferForUserRequest,
  IUserFindOutgoingTransferForUserParams,
  IUserFindOutgoingTransferForUserResponse,
} from '@/app-package';
import { BuildJsonType } from '@bb/domain/dist/typeHelpers';

const findOutgoingTransferUser = async (
  params: IUserFindOutgoingTransferForUserParams,
) => {
  const config: IUserFindOutgoingTransferForUserRequest = {
    url: `transfer/outgoing/${params.userId}`,
    method: 'get',
  };

  const { data } =
    await axios.request<IUserFindOutgoingTransferForUserResponse>(config);

  return data;
};

type OutgoingTransferUser = IUserFindOutgoingTransferForUserResponse;

export { findOutgoingTransferUser, OutgoingTransferUser };
